import { generateContext } from '../../utils'

export interface IMatchingFlagContext {
    toggle: boolean
    setToggle: (toggle: boolean) => void
    excludedLots: string[]
    setExcludedLots: (lots: string[]) => void
    loading: boolean
    saving: boolean
    handleSubmit: () => void
    hasChanges: boolean
    invalidLots: string[]
    clearInvalidLots: () => void
}
const [MatchingFlagContext, MatchingFlagProvider] = generateContext<IMatchingFlagContext>()
export { MatchingFlagContext, MatchingFlagProvider }
